import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KnBrContactComponent } from './kn-br-contact/kn-br-contact.component';
import { ConfigModule, CmsConfig, AuthGuard } from '@spartacus/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PhoneMaskDirective } from './kn-br-phone-mask.directive';
import { KnBrMessageDialogModule } from '../common/kn-br-message-dialog/kn-br-message-dialog.module';
import { FormErrorsModule } from '@spartacus/storefront';
import { CwtSpinnerModule } from '../common/cwt-spinner/cwt-spinner.module';
import { NgSelectModule } from '@ng-select/ng-select';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        KnBrMessageDialogModule,
        FormErrorsModule,
        CwtSpinnerModule,
        NgSelectModule,
        ConfigModule.withConfig({
            cmsComponents: {
                CwtRegistrationFormComponent: {
                    component: KnBrContactComponent,
                },
            },
        } as CmsConfig),
        KnBrContactComponent,
        PhoneMaskDirective,
    ]
})
export class KnBrContactModule { }
